import Vue from "vue";
import moment from "moment";

Vue.filter("formatDate", function (value) {
  if (!value) return "";
  return moment(String(value)).format("DD.MM.YYYY");
});

Vue.filter("formatDateMonthYear", function (value) {
  if (!value) return "";
  return moment(String(value)).format("MM.YYYY");
});
